class CardVariantQuickAdd extends HTMLElement {
  constructor() {
    super();

    this.select = this.querySelector('select[name="id"]');
    this.priceTarget = this.closest('.card-wrapper')?.querySelector('[data-card-variant-price-value]');

    if (!this.select || !this.priceTarget) return;

    this.select.addEventListener('change', this.updateVariant.bind(this));
    this.updateVariant();
  }

  updateVariant() {
    const selectedOption = this.select.options[this.select.selectedIndex];
    const price = selectedOption?.dataset.price;

    if (price) this.priceTarget.textContent = price;

    const cardWrapper = this.closest('.card-wrapper');
    const isHolographic = window.HolographicEffect?.matches(selectedOption?.dataset.variantTitle);
    cardWrapper?.classList.toggle('is-holographic', Boolean(isHolographic));
  }
}

if (!customElements.get('card-variant-quick-add')) {
  customElements.define('card-variant-quick-add', CardVariantQuickAdd);
}
